var exports = {
  "F": "xb99ab02a--9c0605--link-container",
  "n": "xb99ab02a--9c0605--link",
};

module.exports = exports;
